import {
  GET_PLATFORM_SETTINGS,
  GET_PLATFORM_SETTINGS_SUCCESS,
  GET_PLATFORM_SETTINGS_ERROR,
} from "./actionTypes"

const INIT_STATE = {
  platform_settings: null,
  error: null,
  loading: false,
}
const PlatformSettings = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PLATFORM_SETTINGS:
      return {
        ...state,
        error: null,
        loading: true,
      }

    case GET_PLATFORM_SETTINGS_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        platform_settings: action.payload,
      }

    case GET_PLATFORM_SETTINGS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    default:
      return state
  }
}

export default PlatformSettings;
